class LiveSearchWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    this.liveSearch = this.querySelector("live-search");
    this.clear = this.querySelector("[data-clear]");

    if (!this.input || !this.liveSearch) return;

    this.toggleClearVisibility();

    this.input.addEventListener("input", () => {
      this.liveSearch.setAttribute("q", this.input.value);
      this.toggleClearVisibility();
    });

    const handleClear = () => {
      this.input.value = "";
      this.liveSearch.setAttribute("q", "");
      this.toggleClearVisibility();
    };

    if (this.clear) {
      this.clear.addEventListener("click", handleClear);
    }

    this.addEventListener("live-search-wrapper:clear", handleClear);

    this.handleMenuClose = () => handleClear();

    document.addEventListener("mobile-menu:close", this.handleMenuClose);
  }

  disconnectedCallback() {
    document.removeEventListener("mobile-menu:close", this.handleMenuClose);
  }

  toggleClearVisibility() {
    this.toggleAttribute("active", this.input.value.length);

    if (!this.clear) return;

    this.clear.style.display = this.input.value.length ? null : "none";
  }
}

if (!customElements.get("live-search-wrapper")) {
  customElements.define("live-search-wrapper", LiveSearchWrapper);
}
